import { useState } from "react";
import { throwResponseError } from "../../utils/api-error-utils";
import { getAuthParams } from "../../utils/pacto-rebates-utils";
import {
    buildAssessmentsExportParams
} from "../utils/installments-assessment-utils";
import ExcelExportUtils from "../../../shared/utils/ExcelExportUtils";

export function useAssessmentsExport() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function exportAssessments({
        cycleId,
        status,
        filters = {},
        sort = "dataApuracao,desc",
        fileName = "apuracoes-parcelas.csv"
    } = {}) {
        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const params = buildAssessmentsExportParams({
                cycleId,
                status,
                filters,
                sort
            });

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                `pacto-rebates-apuracao/v1/apuracoes/exportacao?${params.toString()}`,
                {
                    method: "GET",
                    headers: {
                        "Accept": "text/csv",
                        "access_token": accessToken,
                        "client_id": clientId
                    }
                }
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível exportar as apurações de parcelas."
                );
            }

            const blob = await response.blob();

            const csvBlob = blob.type
                ? blob
                : new Blob([blob], { type: "text/csv;charset=utf-8" });

            const responseFileName = ExcelExportUtils.getFileNameFromContentDisposition(
                response.headers.get("Content-Disposition")
            );

            const downloadFileName = ExcelExportUtils.addTimestampToFileName(
                responseFileName || fileName
            );

            ExcelExportUtils.downloadBlobFile({
                blob: csvBlob,
                fileName: downloadFileName
            });

            return {
                ok: true
            };
        } catch (requestError) {
            const errorMessage =
                requestError.message ||
                "Não foi possível exportar as apurações de parcelas.";

            setError(errorMessage);

            return {
                ok: false,
                reason: "request",
                error: errorMessage
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        exportAssessments
    };
}